import { Component, computed, inject, input } from '@angular/core';
import { Store } from '@ngxs/store';

import { ClientRequestItemStatus, RequestItem } from '@aiwyn/api';
import { LaunchDarklyFlag, LaunchDarklyService } from '@aiwyn/config';
import { toSignal } from '@angular/core/rxjs-interop';
import { ClientRequestsState, SetSelectedRequestItemId } from 'src/app/features/client-requests/state';

@Component({
  selector: 'awn-request-item-line',
  templateUrl: './request-item-line.component.html',
  styleUrl: './request-item-line.component.scss',
  standalone: false,
})
export class RequestItemLineComponent {
  requestItem = input<RequestItem>();
  dataSelectorStr = input<string>();
  sectionReferenceId = input<string | undefined>(undefined);

  selectedRequestItemId = toSignal(this.store.select(ClientRequestsState.getSlices.selectedRequestItemId));

  // LaunchDarkly flag for IN_REVIEW items editing
  protected isInReviewEditingEnabled = toSignal(
    inject(LaunchDarklyService).getFeatureFlag(LaunchDarklyFlag.ENABLE_IN_REVIEW_ITEMS_EDITING),
    {
      initialValue: false,
    },
  );

  // Computed reference ID for the item
  protected itemReferenceId = computed(() => {
    const sectionRef = this.sectionReferenceId();
    const itemRef = this.requestItem()?.referenceId;

    if (sectionRef && itemRef) {
      return `${sectionRef}.${itemRef}`;
    }
    return null;
  });

  get isReadyToSubmit() {
    return this.requestItem()?.isReadyToSubmit ?? false;
  }

  get shouldHighlight() {
    const item = this.requestItem();
    const isInReviewEditingEnabled = this.isInReviewEditingEnabled();

    // Show highlight if item is ready to submit AND
    // (it's not IN_REVIEW OR the feature flag is enabled)
    return item?.isReadyToSubmit && (item.status !== ClientRequestItemStatus.IN_REVIEW || isInReviewEditingEnabled);
  }

  constructor(private store: Store) {}

  navigateToAnchor(requestItemId: number): void {
    this.store.dispatch(new SetSelectedRequestItemId(requestItemId));
  }

  protected readonly ClientRequestItemStatus = ClientRequestItemStatus;
}
